import { SITE, SITE_COPY } from "@jipraks/shared";

interface PageMetaProps {
  title?: string;
  description?: string | null;
  /** Canonical path; omit for pages that should not declare one. */
  path?: string;
  imageUrl?: string | null;
  isIndexable?: boolean;
}

/**
 * Head tags for client-side navigation (React 19 hoists these into <head>). The first load is
 * covered by the server renderer; main.tsx removes its tags so the two never duplicate.
 */
export function PageMeta({ title, description, path, imageUrl, isIndexable = true }: PageMetaProps) {
  const fullTitle = !title
    ? SITE_COPY.defaultTitle
    : title.includes(SITE.name)
      ? title
      : `${title} — ${SITE.name}`;
  const text = description ?? SITE_COPY.defaultDescription;
  const canonical = path ? `${window.location.origin}${path}` : undefined;
  const image = imageUrl ?? `${window.location.origin}${SITE.ogImagePath}`;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={text} />
      <meta name="robots" content={isIndexable ? "index, follow" : "noindex, follow"} />
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={text} />
      <meta property="og:image" content={image} />
      {canonical && <meta property="og:url" content={canonical} />}
    </>
  );
}
